import { ConfigEditor } from "./ConfigEditor.js";
import { ExecutionView } from "./ExecutionView.js";
import { Icon } from "./Icon.js";
import { configSchema, dataSchema, defaultConfig } from "./schema.js";
export const inputFileUploadPlugin = {
    slug: "input-file-upload",
    name: "File Upload",
    description: "Allow users to upload files",
    type: "input",
    completionType: "user_confirm",
    configSchema,
    dataSchema,
    defaultConfig,
    handlers: {
        onComplete: (ctx, data) => {
            ctx.logger.info("Files uploaded", {
                actionId: ctx.execution.moduleActionId,
                userId: ctx.userId,
                fileCount: data.fileUrls.length,
            });
            return Promise.resolve();
        },
    },
    components: {
        Icon,
        ConfigEditor,
        ExecutionView,
    },
    order: 2,
    version: "1.0.0",
    author: "Nucleus Team",
};
//# sourceMappingURL=index.js.map